<template>
  <div>
    <b-modal
      id="logModal"
      ref="logModal"
      hide-footer
      hide-header
      :no-enforce-focus="true"
      no-close-on-backdrop
      no-close-on-esc
      @hidden="fechar()"
    >
      <div>
        <b-row>
          <b-col style="text-align: center;">
            <span class="text-align:center">
              <b-img
                :src="bemvindoImg"
                width="72"
              />
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <divisoria-descricao
              :titulo="'Bem vindo ao Portal Honorarium'"
              :descricao="'Antes de acessar seu Portal de Documentos, selecione a empresa que deseja trabalhar.'"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <empresa-usuario-externo-select v-model="empresaSelecionada" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-btn
              variant="success"
              size="sm"
              class="w-100"
              @click="aplicar()"
            >
              Confirmar
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
button.close {
  font-weight: bold;
}
</style>

<script>
import { mapActions } from 'vuex'

const img = require('./welcome.png')

export default {
  components: {
    EmpresaUsuarioExternoSelect: () => import('@/shared/components/empresa-usuario-externo-select/EmpresaUsuarioExternoSelect.vue'),
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
  },
  data() {
    return {
      bemvindoImg: img,
      empresaSelecionada: {},
    }
  },
  created() {
    this.$nextTick(() => {
      this.show()
    })
  },
  beforeDestroy() {
    this.fechar()
  },
  methods: {
    ...mapActions('empresaExGlobal', ['setEmpresa']),
    show() {
      this.$refs.logModal.show()
    },
    fechar() {
      this.$refs.logModal.hide()
    },
    aplicar() {
      if (this.empresaSelecionada && this.empresaSelecionada.id > 0) {
        this.setEmpresa(this.empresaSelecionada)
        this.$router.push({ name: 'portaldocumentos-externo' })
      }
    },
  },
}
</script>
